import Icon1 from "../../icons/Icon";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
} from "../../models/DataFunctions";

export const isFolderAdmin = (orgData, folderData) => {
  if (orgData && folderData) {
    if (orgData.id === folderData.master_id) {
      return true;
    }
    if ((folderData.admins_id || []).includes(orgData.id)) {
      return true;
    }
  }
  return false;
};

export const isOECorAdmin = (orgData) => {
  if (
    orgData?.email === "rapport@ouestenergiecontrole.fr" ||
    orgData?.email === "william.bresso@gmail.com"
  ) {
    return true;
  } else {
    return false;
  }
};

export const isFolderClient = (orgData, folderData) => {
  if (orgData && folderData) {
    if (orgData.id === folderData.client_id) {
      return true;
    }
  }
  return false;
};

export const isFolderAdminOrClient = (orgData, folderData) => {
  if (orgData && folderData) {
    if (isFolderAdmin(orgData, folderData)) {
      return true;
    }
    if (isFolderClient(orgData, folderData)) {
      return true;
    }
  }
  return false;
};

export const FolderTypeIcon = ({ type }) => {
  switch (type) {
    case "infiltro":
      return (
        <div className="bg-indigo-50 p-0.5 rounded-md border-b-1 border-indigo-400 w-fit">
          <Icon1 icon_name="debit" fill="#6366f1" size={20} />
        </div>
      );
    case "audit":
      return (
        <div className="bg-indigo-50 p-0.5 rounded-md border-b-1 border-indigo-400 w-fit">
          <Icon1 icon_name="search" fill="#6366f1" size={20} />
        </div>
      );
    case "thermo":
      return <Icon1 icon_name="hexagone-thermo" size={20} />;
    case "basic":
      return <Icon1 icon_name="hexagone-basic" size={20} />;
  }
};

export const getCommunWorkspace = async (orgData, masterData) => {
  if (!orgData || !masterData) {
    return null;
  }
  let all_workspaces = await getArrayDocDataByID(
    "workspace",
    orgData.workspaces_id || []
  );
  let commun_workspaces = all_workspaces.find((w) => {
    return w.master_id === masterData.id;
  });
  return commun_workspaces;
};

export const getFolderTypeName = (type) => {
  switch (type) {
    case "infiltro":
      return "INFILTRO";
    case "audit":
      return "AUDIT";
    case "thermo":
      return "BE";
    case "basic":
      return "BASIQUE";
    default:
      return "";
  }
};
